// extracted by mini-css-extract-plugin
export default {"lists":"Homepage_lists__BI8-N","message":"Homepage_message__J0aeL"};